(function() {
    'use strict';
    angular
        .module('bhsApp')
        .factory('DataElement', DataElement);

    DataElement.$inject = ['$resource'];

    function DataElement ($resource) {
        var resourceUrl =  'api/data-elements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
